import { normalizeFeatureFlags } from '@atlaskit/editor-common/normalize-feature-flags';
import type { FeatureFlags } from '@atlaskit/editor-common/types/feature-flags';
import type { EditorProps } from '@atlaskit/editor-core/editor';

/**
 * Transforms EditorProps's featureFlags to an normalized FeatureFlags object,
 * which is used by both current and archv3 editors.
 *
 * copied and modied from platform/packages/editor/editor-core/src/create-editor/feature-flags-from-props.ts
 */
export function createFeatureFlagsFromProps(
	featureFlags: EditorProps['featureFlags'],
): FeatureFlags {
	const normalizedFeatureFlags = normalizeFeatureFlags(featureFlags);

	// IMPORTANT: If you add a new feature flag here, please make sure to add it to the
	// `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
	return {
		...normalizedFeatureFlags,

		catchAllTracking: false,

		showAvatarGroupAsPlugin: false,

		errorBoundaryDocStructure: false,

		synchronyErrorDocStructure: false,

		enableViewUpdateSubscription: false,

		collabAvatarScroll: false,
		twoLineEditorToolbar: false,

		disableSpellcheckByBrowser: undefined,
	};
}
